import React, {useState,useEffect} from 'react';
import {RouteComponentProps, Redirect, Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useReactRouter from 'use-react-router';
import useStyles from './Styles';
//import Modal from '@mui/material/Modal';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import {Inc,Owner,Book,BookOption} from './Inc';
import {Tools} from './Tools';
import MultiLines from './MultiLines';
import Ajax from './Ajax';
import RowData from './RowData';
import StoreImg from './StoreImg';
import Title from './Title';
import BookVersion from './imgs/book_version.gif';
import BookInputBase from './BookInputBase';
import BookInputPrice from './BookInputPrice';
import BookInputCover from './BookInputCover';
import BookInputText from './BookInputText';
import BookPreview from './BookPreview';
import BottomButtons from './BottomButtons';
import Yesno from './Yesno';
import Toast from './Toast';
import Loading from './Loading';
import nopic from './imgs/no_book_cover.gif';

interface BookDetailProps {
    owner:Owner,
	managerId:number,
    cache_key:string,
}

interface RCProps extends RouteComponentProps<{id:string}> {
	
}

interface Param {
    steps:boolean[],
}

//let isLoading:boolean = true;
//let itemId = 0;

const BookDetail = (props:BookDetailProps)=> {
    Ajax.setEditorId(props.owner.owner_id);

    const rcp:RCProps = useReactRouter();
    const classes = useStyles();
    const defNumbers:number[] = [];
    const defParam:Param = {
        steps:[],
    }
    const [states,setStates] = useState({
        book: Inc.defaultBook(),
        param: defParam,
        photo_ids:defNumbers,
        option:Inc.defaultBookOption(),
        notFound: false,
        modalId: "",
        toast: "",
        preview: false,
        send: false,
        isLoading: true,
    });
    const load = ()=>{
        const itemId = parseInt(rcp.match.params.id);
        Ajax.send("book/get",{item_id:itemId},(res:any)=>{
            //console.log(res);
            //isLoading = false;
            if( res.ok ){
                setStates({book:Inc.convBook(res.book),param:res.param,photo_ids:res.photo_ids,option:Inc.convBookOption(res.option),notFound:false,preview:false,send:false,toast:"",modalId:"",isLoading:false});
            } else {
                setStates({...states,notFound:true,isLoading:false});
            }
        });
    }
    const change = (book:Book,photo_ids?:number[])=>{
        let steps = states.param.steps;
        if( states.modalId==="A" ){
            steps[0] = true;
        }
        if( states.modalId==="B" ){
            steps[1] = true;
        }
        if( states.modalId==="C" ){
            steps[2] = true;
        }
        if( states.modalId==="D" ){
            steps[3] = true;
        }
        if( photo_ids ){
            setStates({...states,book:book,photo_ids:photo_ids,modalId:"",param:{...states.param,steps:steps}});
        } else {
            setStates({...states,book:book,modalId:"",param:{...states.param,steps:steps}});
        }
    }
    const changeOption = (book:Book,option:BookOption)=>{
        let steps = states.param.steps;
        if( states.modalId==="A" ){
            steps[0] = true;
        }
        if( states.modalId==="B" ){
            steps[1] = true;
        }
        if( states.modalId==="C" ){
            steps[2] = true;
        }
        if( states.modalId==="D" ){
            steps[3] = true;
        }
        setStates({...states,book:book,option:option,modalId:"",param:{...states.param,steps:steps}});
    }
    const openModal = (e: React.MouseEvent<HTMLElement>)=>{
        if( e.currentTarget.dataset.id ){
            setStates({...states,preview:false,modalId:e.currentTarget.dataset.id});
        }
    }
    const closeModal = ()=>{
        setStates({...states,modalId:""});
    }
    const openPreview = ()=>{
        setStates({...states,preview:true});
    }
    const sendConfirm = ()=>{
        setStates({...states,send:true});
    }
    const closeToast = ()=>{
        setStates({...states,toast:""});
    }
    const sendYes = ()=>{
        setStates({...states,send:false,isLoading:true});
        Ajax.send("book/admit",{item_id:states.book.item_id},(res:any)=>{
            if( res.ok ){
                setStates({...states,toast:"申請しました。",book:Inc.convBook(res.book),send:false,isLoading:false});
            } else {
                setStates({...states,toast:"データの送信に失敗しました。",send:false,isLoading:false});        
            }
        },(err:any)=>{
            setStates({...states,toast:"データの送信に失敗しました。",send:false,isLoading:false});        
        })
    }
    const sendNo = ()=>{
        setStates({...states,send:false});
    }
    useEffect( ()=>{
        window.scrollTo(0,0);
        if( rcp.match.params.id ){
            if( rcp.match.params.id==="new" ){
                //itemId = 0;
                setStates({...states,modalId:"A",isLoading:false});
            } else {
                //itemId = parseInt(rcp.match.params.id);
                load();
            }
        }
    },[]);

    if( states.notFound ){
		if( props.owner.owner_id===0 ){
	        return (
    	        <Redirect to="/profile"/>
        	);
		} else {
	        return (
    	        <Redirect to="/"/>
        	);
		}
    }

    let completed = false;
    if( states.param.steps[0] && states.param.steps[1] && states.param.steps[2] && states.param.steps[3] ){
        completed = true;
    }

	//return <Redirect to="/sorry"/>

    return (
		<div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                    <Paper className={classes.paper}>
                        <Title text="戯曲詳細" icon="book"/>
                        <div style={{marginBottom:"1em"}}>
                            「基本情報」「原稿」「価格と販売情報」「表紙」の全てを設定し終わると、販売許可の申請やＰＤＦの試し出力ができるようになります。<br/>
                            お好きな手順で設定を進めて下さい。いずれの項目も、何度でも変更が可能です。<br/>
                        </div>

                        <Hidden mdUp implementation="js">
                            {states.preview &&
                            <BookPreview book={states.book} owner={props.owner}/>
                            }
							<BottomButtons
								button1='販売許可申請' onClick1={sendConfirm} disabled1={!completed || states.book.admit_id!=="0"}
								button2='一覧' link2='/book'
								button3='プレビュー' disabled3={!completed} onClick3={openPreview}
							/>
                        </Hidden>

                        <Divider style={{marginBottom:"1em"}}/>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={7}>
                                {states.param.steps[0] &&
                                <div className="bookMain">
                                    <div className="img">
                                        {states.book.img_id>0 ? (
                                        <StoreImg
                                            owner_id={props.owner.owner_id}
                                            img_id={states.book.img_id}
                                            thumb={false}
                                            className="imgItemLarge"
                                        />
                                        ):(
                                        <img src={nopic}/>
                                        )}
                                    </div>
                                    <div className="text">
                                        <div className="title">{states.book.book_name}</div>
                                        <div className="subtitle">{states.book.book_name_sub}</div>
                                        <div className="status">{Tools.colorLabel("item_status",states.book.status,states.book.status_label)}</div>
                                        {states.book.price>0 &&
                                        <div className="price">{Tools.comma(states.book.price)}円（税込）</div>
                                        }
                                    </div>
                                </div>
                                }
                                {states.param.steps[2] &&
                                <div className="bookSpec">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <th>総ページ数</th>
                                                <td>{states.book.num_page >0 ? (
                                                    <span>{states.book.num_page}P</span>
                                                ):(
                                                    <span>不明</span>
                                                )}</td>
                                                <th>上演時間</th>
                                                <td>{states.book.perform_time_id!=="" ? (
                                                    <span>{Tools.getLabel(Inc.performTimes,states.book.perform_time_id)}</span>
                                                ):(
                                                    <span>未定</span>
                                                )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>役者人数</th>
                                                <td>{states.book.perform_member_id!=="" ? (
                                                    <span>{Tools.getLabel(Inc.performMembers,states.book.perform_member_id)}</span>
                                                ):(
                                                    <span>未定</span>
                                                )}
                                                </td>
                                                <th>上演許可</th>
                                                <td>{states.book.perform_admit_id!=="" ? (
                                                    <span>{Tools.getLabel(Inc.performAdmits,states.book.perform_admit_id)}</span>
                                                ):(
                                                    <span>未定</span>
                                                )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div style={{fontSize:"80%",textAlign:"right"}}>※総ページ数は販売許可後に架空ストアが設定します</div>
                                </div>
                                }

                                <Hidden smDown implementation="js">
                                    <React.Fragment>
                                {states.param.steps[0] &&
                                <div className="bookPersons">
                                    <div className="bookKey">登場人物</div>
                                    <MultiLines text={states.book.persons} autolink={true}/>
                                </div>
                                }

                                {states.param.steps[0] &&
                                <div className="bookHistory">
                                    <div className="bookKey">上演記録</div>
                                    <MultiLines text={states.book.history} autolink={true}/>
                                </div>
                                }
                                            
                                {states.param.steps[2] &&
                                <div className="bookNotice">
                                    <div className="bookKey">紹介文</div>
                                    <MultiLines text={states.book.notice} autolink={true}/>
                                </div>
                                }

                                <div className="bookPhotos">
                                    <div className="bookKey">上演写真・宣伝写真</div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px'}}>
                                        {states.photo_ids.map((img_id:number,index:number)=>{
                                            const key = "img"+index;
                                            return (
                                                <div key={key} style={{ flex: '0 0 auto', width: '100px', height: '75px' }}>
                                                    <StoreImg
                                                        owner_id={props.owner.owner_id}
                                                        img_id={img_id}
                                                        thumb={true}
                                                        className="imgItemPhoto"
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                                    </React.Fragment>
                                </Hidden>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <div className="bookStepBox">
                                    <h3 className="bookEditor"><span>A</span>基本情報</h3>
                                    <div className="bookStepGuide">
                                        タイトルや登場人物一覧など、電子書籍に記載される情報を設定します。
                                    </div>
                                    <div className="bookStepBtn">
                                        <Button variant="outlined" color="primary" onClick={openModal} data-id="A"><EditIcon style={{marginRight:"0.5em"}}/>設定</Button>
                                    </div>
                                    {states.param.steps[0] ? (
                                    <div className="bookStepCheck done">
                                        <DoneIcon/>OK
                                    </div>
                                    ):(
                                    <div className="bookStepCheck empty">
                                        未登録
                                    </div>
                                    )}
                                </div>
                                <div className="bookStepBox">
                                    <h3 className="bookEditor"><span>B</span>原稿</h3>
                                    <div className="bookStepGuide">
                                        戯曲の原稿をアップロードし、セリフとト書きの判別などを行います。
                                    </div>
                                    <div className="bookStepBtn">
                                        <Button variant="outlined" color="primary" onClick={openModal} data-id="B"><EditIcon style={{marginRight:"0.5em"}}/>設定</Button>
                                    </div>
                                    {states.param.steps[1] ? (
                                    <div className="bookStepCheck done">
                                        <DoneIcon/>OK
                                    </div>
                                    ):(
                                    <div className="bookStepCheck empty">
                                        未登録
                                    </div>
                                    )}
                                </div>
                                <div className="bookStepBox">
                                    <h3 className="bookEditor"><span>C</span>価格と販売情報</h3>
                                    <div className="bookStepGuide">
                                        価格やあらすじなど、架空ストアの商品ページに表示される情報を設定します。<br/>
                                        これらの情報は、電子書籍の中には記載されません。<br/>
                                    </div>
                                    <div className="bookStepBtn">
                                        <Button variant="outlined" color="primary" onClick={openModal} data-id="C"><EditIcon style={{marginRight:"0.5em"}}/>設定</Button>
                                    </div>
                                    {states.param.steps[2] ? (
                                    <div className="bookStepCheck done">
                                        <DoneIcon/>OK
                                    </div>
                                    ):(
                                    <div className="bookStepCheck empty">
                                        未登録
                                    </div>
                                    )}
                                </div>
                                <div className="bookStepBox">
                                    <h3 className="bookEditor"><span>D</span>表紙</h3>
                                    <div className="bookStepGuide">
                                        電子書籍（PDF）の表紙を設定します。チラシの写真など、画像を使うことも可能です。
                                    </div>
                                    <div className="bookStepBtn">
                                        <Button variant="outlined" color="primary" onClick={openModal} data-id="D"><EditIcon style={{marginRight:"0.5em"}}/>設定</Button>
                                    </div>
                                    {states.param.steps[3] ? (
                                    <div className="bookStepCheck done">
                                        <DoneIcon/>OK
                                    </div>
                                    ):(
                                    <div className="bookStepCheck empty">
                                        未登録
                                    </div>
                                    )}
                                </div>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Paper className={classes.paper}>
                        <Title text="管理情報" size={2}/>
                        <RowData name="商品ID" value={String(states.book.item_id)}/>
                        <RowData name="バージョン" value={states.book.book_version} ifnull="0.000"/>
                        <RowData name="状態" value={states.book.status_label} ifnull="新規作成"/>
                        <RowData name="販売許可" value={states.book.admit} ifnull="未申請"/>
                       
                        <Hidden mdDown implementation="js">
                            <Divider style={{margin:"1em 0"}}/>
                            {states.preview &&
                            <BookPreview book={states.book} owner={props.owner}/>
                            }
                            <Grid container spacing={1}>
                                {!states.preview &&
                                <Grid item xs={12} lg={12}>
                                    <Button variant="contained" color="primary" style={{width:"100%"}} onClick={openPreview} disabled={!completed}>プレビューする</Button>
                                </Grid>
                                }
                                <Grid item xs={12} lg={12}>
                                    <Button variant="contained" color="primary" style={{width:"100%"}} onClick={sendConfirm} disabled={!completed || states.book.admit_id!=="0"}>販売許可を申請する</Button>
                                </Grid>
                                <Grid item xs={12} lg={12}>
                                    <Link to="/book"><Button variant="outlined" style={{width:"100%"}}>一覧にもどる</Button></Link>
                                </Grid>
                            </Grid>
                        </Hidden>

                        <div id="book_version_guide" className="book_version_guide">
                            <h3>プレビューとは？</h3>
                            <div className="box">
                                <p>
                                    実際に電子書籍（PDF）を出力し、現在の登録内容を確認することができます。
                                </p>
                            </div>

                            <h3>バージョンとは？</h3>
                            <div className="box">
                                <p>
                                    バージョンは戯曲の更新状況を示します。
                                </p>
                                <img src={BookVersion} alt="バージョンとは？" title="バージョンとは？" style={{maxWidth:'320px'}}/>
                                <p>
                                    基本情報または原稿に変更があると、バージョン番号が更新されます。それ以外の情報はバージョンと特に関係はありません。
                                </p>
                                <p>
                                    ただし、バージョンが変化するのは販売許可が済んだ戯曲だけです。販売許可が済むまでは、どんな変更を行ってもバージョンは1.000のまま変わりません。
                                </p>
                            </div>

                            <h3>バージョンが変わるとどうなる？</h3>
                            <div className="box">
                                <p>
                                    購入者には常に最新のバージョンが提供されます。<br/>
                                </p>
                                <p>
                                    古いバージョンを購入されたお客様で、購入日から１８０日が過ぎていない場合には、アップデートＵＲＬ（最新の内容のバージョンがダウンロードできるＵＲＬ）が発行されます。<br/>
                                </p>
                                <p>
                                    ただし、アップデートＵＲＬの発行は１か月に１回までとし、頻繁に変更が行われた場合には、架空ストアが適当と判断するタイミングで１か月に１回だけお知らせいたします。<br/>
                                </p>
                            </div>

                        </div>                        
                    </Paper>
                </Grid>
            </Grid>
			<Loading isLoading={states.isLoading}/>
            <Toast close={closeToast} mes={states.toast}/>
            <Yesno mes="この戯曲の販売許可を申請します。よろしいですか？" yes={sendYes} no={sendNo} isOpen={states.send}/>
            <Dialog
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={states.modalId!==""}
				onClose={(event:object, reason:string) => {
					if (reason !== 'backdropClick') {
						closeModal();
					}
				}}	
				disableEscapeKeyDown={true}
				maxWidth="lg"
            >
				<DialogContent style={{padding:"0",margin:"0"}}>
					{states.modalId==="A" &&
                    <BookInputBase owner={props.owner} managerId={props.managerId} change={change} close={closeModal} book={states.book}/>
                    }
                    {states.modalId==="B" &&
                    <BookInputText owner={props.owner} change={changeOption} close={closeModal} book={states.book} option={states.option} cache_key={props.cache_key}/>
                    }
                    {states.modalId==="C" &&
                    <BookInputPrice owner={props.owner} change={change} close={closeModal} book={states.book} photoIds={states.photo_ids}/>
                    }
                    {states.modalId==="D" &&
                    <BookInputCover owner={props.owner} change={changeOption} close={closeModal} book={states.book} option={states.option}/>
                    }
				</DialogContent>
            </Dialog>

		</div>
	);
}

export default BookDetail;
